module.exports = __webpack_public_path__ + "static/media/mileage_2_3.105c1096.png";